import axios from 'axios'
import {
    GET_MONTHLY_COLLECTIONS_SUMMARY_REQUEST,
    GET_MONTHLY_COLLECTIONS_SUMMARY_SUCCESS,
    GET_MONTHLY_COLLECTIONS_SUMMARY_FAIL,
    GET_MONTHLY_COLLECTIONS_SUMMARY_RESET,
    GET_MONTHLY_RECOVERY_COLLECTIONS_REQUEST,
    GET_MONTHLY_RECOVERY_COLLECTIONS_SUCCESS,
    GET_MONTHLY_RECOVERY_COLLECTIONS_FAIL,
    GET_MONTHLY_RECOVERY_COLLECTIONS_RESET,
    GET_MONTHLY_FLOW_COLLECTIONS_REQUEST,
    GET_MONTHLY_FLOW_COLLECTIONS_SUCCESS,
    GET_MONTHLY_FLOW_COLLECTIONS_FAIL,
    GET_MONTHLY_FLOW_COLLECTIONS_RESET,
} from '../constants/monthlyMisConstants';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

export const getMonthlyCollectionsSummary = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_MONTHLY_COLLECTIONS_SUMMARY_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/monthlyMis/monthly${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_MONTHLY_COLLECTIONS_SUMMARY_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_MONTHLY_COLLECTIONS_SUMMARY_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getMonthlyRecoveryCollections = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_MONTHLY_RECOVERY_COLLECTIONS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/monthlyMis/monthly/recovery${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_MONTHLY_RECOVERY_COLLECTIONS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_MONTHLY_RECOVERY_COLLECTIONS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getMonthlyFlowCollections = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_MONTHLY_FLOW_COLLECTIONS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/monthlyMis/monthly/flow${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_MONTHLY_FLOW_COLLECTIONS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_MONTHLY_FLOW_COLLECTIONS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};


// Add these alias exports at the end of the file
export const getAllMonthlyCollections = getMonthlyCollectionsSummary;